import { List, Map, fromJS } from 'immutable';

import * as types from './types';
import * as functions from './functions';
import {
  FILTER_AUTOMATED_BUILDS,
  FILTER_AUTOMATED_TESTS,
  FILTER_MANUAL_TESTS,
  FILTER_TYPE_SEARCH,
  FILTER_TYPE_STATUS,
  FILTER_TYPE_OWNERSHIP,
  FILTER_TYPE_PERFORMANCE,
  PERFORMANCE_DEFAULT,
} from './constants';

const initialState = Map({
  filtersInitialized: false,
  orgUsersLoading: false,
  orgTeams: List(),
  orgUsers: List(),
  orgUsersWithIds: List(),
  username: null,
  [FILTER_AUTOMATED_BUILDS]: Map({
    [FILTER_TYPE_STATUS]: List(),
    [FILTER_TYPE_OWNERSHIP]: Map(),
  }),
  [FILTER_AUTOMATED_TESTS]: Map({
    [FILTER_TYPE_STATUS]: List(),
    [FILTER_TYPE_OWNERSHIP]: Map(),
    [FILTER_TYPE_PERFORMANCE]: PERFORMANCE_DEFAULT,
  }),
  [FILTER_MANUAL_TESTS]: Map({
    [FILTER_TYPE_OWNERSHIP]: Map(),
    [FILTER_TYPE_SEARCH]: '',
    [FILTER_TYPE_STATUS]: List(),
  }),
});

const filtersReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INITIALIZE_FILTERS:
      return state.set('filtersInitialized', true);
    case types.GET_ORG_USERS.REQUEST:
      return state.set('orgUsersLoading', true);
    case types.GET_ORG_USERS.SUCCESS:
      return state.withMutations((mutable) => (
        mutable.set('orgUsers', fromJS(payload.results))
          .set('orgUsersLoading', false)
      ));
    case types.TEAMLIST_GET.SUCCESS:
      return state.set('orgTeams', fromJS(payload.results));
    case types.GET_USERS.SUCCESS:
      return state.set('orgUsersWithIds', fromJS(payload.results));
    case types.RESET_FILTERS:
      return initialState.set('username', payload.username);
    case types.SET_SEARCH: {
      return state.setIn([payload.type, FILTER_TYPE_SEARCH], payload.data ?? '');
    }
    case types.TOGGLE_STATUS: {
      const index = state.getIn([payload.type, FILTER_TYPE_STATUS]).indexOf(payload.data);
      const updatedFilters = index === -1 ?
        state.updateIn([payload.type, FILTER_TYPE_STATUS], (status) => status.push(payload.data)) :
        state.updateIn([payload.type, FILTER_TYPE_STATUS], (status) => status.delete(index));
      return updatedFilters;
    }
    case types.CLEAR_STATUSES: {
      const updatedFilters = state.setIn(
        [payload.type, FILTER_TYPE_STATUS],
        initialState.getIn([payload.type, FILTER_TYPE_STATUS]),
      );
      return updatedFilters;
    }
    case types.SELECT_OWNER: {
      const updatedFilters = state.setIn(
        [payload.type, FILTER_TYPE_OWNERSHIP],
        fromJS(payload.data),
      );
      return updatedFilters;
    }

    case types.SELECT_STATUSES:
      return state.setIn([payload.type, FILTER_TYPE_STATUS], fromJS(payload.data));

    case types.UPDATE_FILTERS_FROM_LS: {
      const updatedFilters = initialState.merge(
        functions.deserializeFiltersFromLS(JSON.parse(payload.filters)),
      );
      return updatedFilters;
    }
    case types.CLEAR_OWNER: {
      const updatedFilters = state.setIn(
        [payload.type, FILTER_TYPE_OWNERSHIP],
        initialState.getIn([payload.type, FILTER_TYPE_OWNERSHIP]),
      );
      return updatedFilters;
    }
    case types.TOGGLE_PERFORMANCE: {
      const updatedFilters = state.setIn(
        [FILTER_AUTOMATED_TESTS, FILTER_TYPE_PERFORMANCE],
        payload,
      );
      return updatedFilters;
    }
    default:
      return state;
  }
};

export default filtersReducer;
export { initialState };
